export function PageLayout({ children }: { children: React.ReactNode }) {
  return <main className="px-4 sm:px-6 lg:px-8">{children}</main>;
}
